<template>
  <div class="leftMenu">
    <el-menu :default-active="active" text-color="#CFE7F2" :router="true" unique-opened ref="menu">
      <template v-for="(item, index) in menuList">
        <el-submenu v-if="item.childNode && item.childNode.length > 0" :index="String(index)" :key="index"
          :popper-append-to-body="true">
          <template slot="title">
            <icon class="menu-icon" :name="item.iconPath"></icon>
            <span class="menu-text" slot="title">{{ item.menuName }}</span>
          </template>
          <el-menu-item v-for="(cItem, cIndex) in item.childNode" :index="cItem.url" :key="cIndex">
            <span class="menu-text" slot="title">{{ cItem.menuName }}</span>
          </el-menu-item>
        </el-submenu>
        <el-menu-item v-else :index="item.url" :key="index" class="highlight">
          <icon class="menu-icon" :name="item.iconPath"></icon>
          <span class="menu-text" slot="title">{{ item.menuName }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
import { debounce } from "lodash";
export default {
  name: "LeftMenu",
  props: {
    menuList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  watch: {
    menuList(val) {
      // ***还有一些问题：比如url和path不一致，就会出现跳转问题***
      const isUpate = this.findMenuIndexByUrl(val, this.$route.path)
      if (isUpate === -1) {
        this.$nextTick(() => {
          const url = this.findFirstLeafUrl(val);
          this.$router.replace(url);
          this.UpDataMenuActive();
        });
      }
    },
    // 新增路由监听
    $route: {
      immediate: true,
      handler(newVal, oldVal) {
        this.$nextTick(() => {
          // 强制更新菜单激活状态
          if (newVal) {
            this.UpDataMenuActive();
          }
        });
      },
    },
  },
  computed: {
    // 计算 active 的逻辑
    active() {
      // const path = this.$route.path.split('/')
      // return '/' + path[1] + '?deviceType=' + this.$route.query.deviceType

      // 确保 menuList 存在且不为空
      if (!this.menuList || this.menuList.length === 0) return null;

      // 操作手册的 路径
      if (this.$route.name === "webview") {
        return this.$route.fullPath;
      }

      // 如果路由中有 activeMenu 字段，则直接返回该字段作为 active
      if (this.$route.meta?.activeMenu) {
        return this.$route.meta.activeMenu;
      }

      // 如果路由中没有 activeMenu 字段，则先根据query参数逻辑计算 active
      if (this.$route.query.deviceType) {
        const path = this.$route.path.split("/");
        if (this.$route.meta.backUrl) {
          return (
            this.$route.meta.backUrl +
            "?deviceType=" +
            this.$route.query.deviceType
          );
        } else {
          return "/" + path[1] + "?deviceType=" + this.$route.query.deviceType;
        }
      }

      // 如果路由中没有 activeMenu 字段，也没有 deviceType 参数，则根据路由路径计算 active
      const path = this.$route.path;
      const activePath = path.split("/");
      return "/" + activePath.slice(1, 3).join("/");
    },
  },
  created() { },
  methods: {
    UpDataMenuActive: debounce(function () {
      if (this.$refs.menu) {
        this.$refs.menu.activeIndex = null;
        this.$nextTick(() => {
          this.$refs.menu.activeIndex = this.active;
        });
      }
    }, 100),
    findFirstLeafUrl(menuList) {
      // 处理空数组或无效输入
      if (!Array.isArray(menuList) || menuList.length === 0) {
        return null; // 或根据需求返回 undefined/空字符串
      }

      // 定义递归函数：深度优先搜索第一个叶子节点
      const getFirstLeaf = (node) => {
        // 检查是否有子节点且子节点数组非空
        if (node.childNode && node.childNode.length > 0) {
          // 递归处理第一个子节点
          return getFirstLeaf(node.childNode[0]);
        } else {
          // 当前节点是叶子节点，返回 url
          return node.url || null; // 处理无 url 的情况
        }
      };
      // 从第一个菜单项开始查找
      return getFirstLeaf(menuList[0]);
    },
    findMenuIndexByUrl(menuList, url, currentIndex = 0) {
      if (!menuList || currentIndex >= menuList.length) {
        return -1; // 遍历结束未找到或menuList为空
      }

      const currentItem = menuList[currentIndex];

      // 检查当前项的url是否匹配
      if (currentItem.url === url) {
        return currentIndex;
      }

      // 如果有childNode且不为空，递归查找
      if (currentItem.childNode && currentItem.childNode.length > 0) {
        const childIndex = this.findMenuIndexByUrl(currentItem.childNode, url);
        if (childIndex !== -1) {
          return currentIndex; // 返回父级的index
        }
      }

      // 继续检查下一项
      return this.findMenuIndexByUrl(menuList, url, currentIndex + 1);
    },
  },
};
</script>

<style scoped lang="scss">
.leftMenu {
  width: 180px;
  overflow-x: hidden;

  ::v-deep {
    .el-menu--inline {
      background: linear-gradient(180deg, #243140 0%, #355165 100%);
    }

    .el-submenu {
      &.is-active {
        .el-submenu__title {
          background: radial-gradient(221% 121% at 50% 100%,
              #81c1f0 0%,
              rgba(29, 46, 53, 0) 100%);

          .menu-text {
            color: #53e7ff;
            font-weight: 600;
          }

          .menu-icon {
            color: #53e7ff;
          }
        }
      }

      .el-submenu__title {
        &:hover {
          background-color: #005394;
        }
      }
    }

    .el-menu {
      &:not(.el-menu--inline) {
        >.el-menu-item {
          &.is-active {
            background: radial-gradient(221% 121% at 50% 100%,
                #81c1f0 0%,
                rgba(29, 46, 53, 0) 100%);

            .menu-text {
              color: #53e7ff;
              font-weight: 600;
            }

            .menu-icon {
              color: #53e7ff;
            }
          }
        }
      }

      .el-menu--inline {
        >.el-menu-item {
          &.is-active {
            position: relative;

            .menu-text {
              color: #53e7ff;
            }

            &::before {
              content: "";
              width: 4px;
              height: 4px;
              position: absolute;
              top: 20px;
              left: 45px;
              background: #53e7ff;
            }
          }
        }
      }
    }
  }

  .el-menu {
    border: 0;
    background: transparent;

    .el-menu-item {
      &:hover {
        background-color: #005394;
      }

      &:focus {
        background-color: transparent;
      }
    }

    .menu-icon {
      width: 16px;
      height: 16px;
      color: #ffffff;
      margin-right: 16px;
    }
  }

  .el-submenu {
    .el-menu-item {
      padding-right: 0;
      min-width: 180px;
      padding-left: 52px !important;
      height: 40px;
      line-height: 40px;
    }
  }
}
</style>
